import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=87988f9e&scoped=true&"
var script = {}
import style0 from "./dashboard.vue?vue&type=style&index=0&id=87988f9e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87988f9e",
  null
  
)

export default component.exports